const origins = [
  {
    continent: "African",
    languageArr: [
      { language: "All", searchKey: "afr" },
      { language: "Eastern African", searchKey: "afr-e" },
      { language: "Northern African", searchKey: "afr-n" },
      { language: "Southern African", searchKey: "afr-s" },
      { language: "Western African", searchKey: "afr-w" },
    ]
  },
  {
    continent: "Asian",
    languageArr: [
      {language:"Arabic", searchKey: "ara"},
      {language:"Chinese", searchKey: "chi"},
      {language:"Filipino", searchKey: "fil"},
      {language:"Hebrew", searchKey: "heb"},
      {language:"Indian", searchKey: "ind"},
      {language:"Indonesian", searchKey: "ins"},
      {language:"Japanese", searchKey: "jap"},
      {language:"Korean", searchKey: "kor"},
      {language:"Persian", searchKey: "per"},
      {language:"Thai", searchKey: "tha"},
      {language:"Turkish", searchKey: "tur"},
      {language:"Vietnamese", searchKey: "vie"},
    ]
  },
  {
    continent: "European",
    languageArr: [
      { language: "Czech", searchKey: "cze" },
      { language: "Danish", searchKey: "dan" },
      { language: "Dutch", searchKey: "dut" },
      { language: "English", searchKey: "eng" },
      { language: "Finnish", searchKey: "fin" },
      { language: "French", searchKey: "fre" },
      { language: "German", searchKey: "ger" },
      { language: "Greek", searchKey: "gre" },
      { language: "Hungarian", searchKey: "hun" },
      { language: "Irish", searchKey: "iri" },
      { language: "Italian", searchKey: "ita" },
      { language: "Norwegian", searchKey: "nor" },
      { language: "Polish", searchKey: "pol" },
      { language: "Portuguese", searchKey: "por" },
      { language: "Russian", searchKey: "" },
      { language: "Scottish", searchKey: "sco" },
      { language: "Spanish", searchKey: "spa" },
      { language: "Swedish", searchKey: "swe" },
      { language: "Ukrainian", searchKey: "ukr" },
      { language: "Welsh", searchKey: "wel" },
    ]
    
  },
  {
    continent: "Other",
    languageArr: [
      { language: "American", searchKey: "usa" },
      { language: "Indiginous American", searchKey: "ame" },
      { language: "Jewish", searchKey: "jew" },
      { language: "Biblical", searchKey: "bibl" },
    ]
  }
]

export default origins